import { Head } from "@inertiajs/react";

import ApparelBanner from "@/theme2/components/apparel/ApparelBanner";
import ApparelCategories from "@/theme2/components/apparel/ApparelCategories";
import ApparelCTA from "@/theme2/components/apparel/ApparelCTA";
import ApparelFeatures from "@/theme2/components/apparel/ApparelFeatures";
import ApparelHero from "@/theme2/components/apparel/ApparelHero";
import ApparelHighlight from "@/theme2/components/apparel/ApparelHighlight";
import ApparelLifestyleGallery from "@/theme2/components/apparel/ApparelLifestyleGallery";
import ApparelProductShowcase from "@/theme2/components/apparel/ApparelProductShowcase";
import ApparelStats from "@/theme2/components/apparel/ApparelStats";
import ApparelStory from "@/theme2/components/apparel/ApparelStory";
import ApparelTestimonials from "@/theme2/components/apparel/ApparelTestimonials";
import { apparelPage } from "@/theme2/data/apparel";

export default function Apparel() {
  return (
    <>
      <Head title={apparelPage.seo.title}>
        <meta
          name="description"
          content={apparelPage.seo.description}
        />
        <meta
          name="keywords"
          content={apparelPage.seo.keywords}
        />
      </Head>

      <main className="overflow-hidden">
        <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8 py-5 sm:py-7 lg:py-10">
          <ApparelHero hero={apparelPage.hero} />

          {/* <ApparelStory story={apparelPage.story} /> */}

          {/* <ApparelHighlight highlight={apparelPage.highlight} /> */}

          {/* <ApparelProductShowcase
            products={apparelPage.featuredProducts}
          /> 

          <ApparelBanner banner={apparelPage.banner} />*/}

           <ApparelLifestyleGallery gallery={apparelPage.gallery} />

        {/*  <ApparelFeatures features={apparelPage.features} /> */}

          {/* <ApparelCategories categories={apparelPage.categories} />

          <ApparelStats statistics={apparelPage.statistics} /> */}

          {/* <ApparelTestimonials
            testimonials={apparelPage.testimonials}
          /> */}

          <ApparelCTA callToAction={apparelPage.callToAction} />
        </div>
      </main>
    </>
  );
}
